import styled, { css } from 'styled-components';
import { Paragraph } from '../../../../../../common/components/Typography/Paragraph/Paragraph';
import { IconThumbTeal } from '../../../../../../common/components/icons/IconThumb/IconThumb';
import { ThemeColours } from '../../../../../../common/styles/ThemeColours';
import {
  FONT_STACK,
  FontWeight,
  FontSize,
  LineHeight,
  Breakpoint,
} from '../../../../../../common/styles/constants';
import { onMobile } from '../../../../../../common/styles/onMobile';

export const RatingView = styled.div<{ tooFew?: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: row;
  ${FONT_STACK}
  justify-content: flex-start;
  line-height: 1em;
  margin-top: 16px;

  ${onMobile} {
    margin-top: 12px;
  }

  ${props =>
    props.tooFew &&
    css`
      font-size: 12px;
    `}
`;

export const ThumbTeal = styled(IconThumbTeal)`
  height: 14px;
  margin-top: 4px;
  width: 11px;
`;

export const Detail = styled.span<{ newLine?: boolean }>`
  color: ${ThemeColours.mono600};
  display: inline;
  font-size: 14px;
  margin-inline-start: 4px;

  ${onMobile} {
    font-size: 12px;
  }

  ${props =>
    props.newLine &&
    css`
      display: block;
      margin-inline-start: 0px;
    `}
`;

export const NoWrapDetails = styled(Detail)`
  white-space: nowrap;
`;

export const View = styled.div<{ tooFew?: boolean }>`
  display: flex;
  flex-direction: row;
  ${FONT_STACK}
  gap: 10px;

  ${props =>
    props.tooFew &&
    css`
      font-size: 12px;
    `}
`;

export const Description = styled(Paragraph)`
  color: ${ThemeColours.mono600};
  font-size: ${FontSize.EXTRA_SMALL};
  font-weight: ${FontWeight.REGULAR};
  line-height: ${LineHeight.EXTRA_SMALL};
  margin: 0;

  ${Breakpoint.SMALL} {
    margin-top: 4px;
  }
`;

export const RatingWrapper = styled.div`
  display: flex;
  gap: 4px;
  min-width: 72px;
`;

export const RatingText = styled(Paragraph)`
  font-size: ${FontSize.HEADING_5};
  font-weight: ${FontWeight.SEMI_BOLD};
  margin: 0;

  ${Breakpoint.SMALL} {
    height: 22px;
  }
`;
